export default __webpack_public_path__ + "static/media/bubbles.faea4d95.svg";